// extracted by mini-css-extract-plugin
module.exports = {"layout":"slideout-card_layout__QzzmD","image":"slideout-card_image__xv4V7","content":"slideout-card_content__JCshd","overlay":"slideout-card_overlay__yCF82"};